import React from "react";
import { useState, useMemo, useEffect } from "react";
import CustomTable from "./CustomTable";
import Loading from "./utils/Loading";
import RecordCount from "./utils/RecordCount";
import { useClaimsDataColumns } from "./useClaimsDataColumns";

const Claims = (props) => {
  const [data, setData] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const columns = useClaimsDataColumns(props.claimType);
  const claimKey = props.claimType == "medical" ? "medical_claims" : "pharmacy_claims";

  useEffect(() => {
    if (!data && props.claims_path) {
      const fetchData = async () => {
        try {
          const response = await fetch(props.claims_path, {
            headers: { Accept: "application/json" },
          });
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const fetchedData = await response.json();

          setData(fetchedData.records);
          setRowCount(fetchedData.row_count);
        } catch (error) {
          console.log("Error fetching data: ", error);
        } finally {
          setIsLoading(false);
        }
      };
      if (!data || data.length === 0) {
        fetchData();
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <React.Fragment>
      {isLoading ? (
        <Loading />
      ) : data ? (
        <>
          {!props.hide_count ? (
            <RecordCount
              record_count={rowCount}
              display_count={data.length}
              record_type="submission claim"
            />
          ) : null}
          {data.length > 0 ? (
            <>
              <div className="pb-2 mb-2">
                <small className="text-muted">340B ID:</small> <b>{props.id_340b}</b>
                <small className="text-muted ms-2">MANUFACTURER:</small>{" "}
                <b>{props.manufacturer_name}</b>
                {props.show_download ? (
                  <a
                    href={`/${claimKey}/download?id_340b=${props.id_340b}&manufacturer=${props.manufacturer}`}
                    download={`${claimKey}.xlsx`}
                    target="_blank"
                    className="btn btn-sm btn-primary ms-2"
                  >
                    <i className="fa fa-download me-1"></i> Download Search Results
                  </a>
                ) : null}
              </div>
              <CustomTable columns={columns} data={data} />
            </>
          ) : null}
        </>
      ) : null}
    </React.Fragment>
  );
};

export default Claims;
